import type { IncludeExcludeFilterCategory } from "../include-exclude-filter/reducers/includeExcludeFilterReducer";

export type LifecycleCategoryTree = ReadonlyArray<{
  solutionArea?: string | null;
  categories?: ReadonlyArray<{
    category?: string | null;
    subCategories?: ReadonlyArray<string | null> | null;
  }> | null;
}>;

const isNonBlank = (value: string | null | undefined): value is string =>
  !!value?.trim();

// `categories` names the tree itself; the other three name its levels.
export const LIFECYCLE_CATEGORY_LABELS = {
  solutionArea: "Category Level 1",
  categories: "Category",
  category: "Category Level 2",
  subCategory: "Category Level 3",
} as const;

export function buildLifecycleCategoryFilterCategory(
  categories: LifecycleCategoryTree | null | undefined,
): IncludeExcludeFilterCategory | undefined {
  if (!categories?.length) {
    return undefined;
  }

  return {
    id: "categories",
    label: LIFECYCLE_CATEGORY_LABELS.categories,
    type: "checkbox",
    options: categories.flatMap((solutionAreaGroup) => {
      const solutionArea = solutionAreaGroup.solutionArea;
      if (!isNonBlank(solutionArea)) {
        return [];
      }

      return [
        {
          item: `solutionArea::${solutionArea}`,
          label: solutionArea,
          checked: false,
          categoryId: "solutionArea",
          subItems: solutionAreaGroup.categories?.flatMap((categoryGroup) => {
            const category = categoryGroup.category;
            if (!isNonBlank(category)) {
              return [];
            }

            return [
              {
                item: `category::${solutionArea}/${category}`,
                label: category,
                checked: false,
                categoryId: "category",
                subItems: categoryGroup.subCategories
                  ?.filter(isNonBlank)
                  .map((subCategory) => ({
                    item: subCategory,
                    checked: false,
                    categoryId: "subCategory",
                  })),
              },
            ];
          }),
        },
      ];
    }),
  };
}
